import { AdminIcon } from '@f8n/icons';

import Badge from 'components/base/Badge';
import Button from 'components/base/Button';
import Modal from 'components/base/Modal';

import useModalVisibility from 'hooks/use-modal-visibility';

import { ModalOptions } from 'types/modal';

const MODAL_KEY = 'CONFIRM';

type Options = ModalOptions<typeof MODAL_KEY>;

export default function ConfirmModal() {
  const modal = useModalVisibility(MODAL_KEY);

  return (
    <Modal.Root open={modal.open} onOpenChange={modal.onOpenChange}>
      <Modal.Portal>
        <Modal.BlurOverlay />
        <Modal.PositionOverlay>
          <Modal.UnmountListener onUnmount={modal.onUnmount} />
          {modal.config && (
            <ConfirmModalWindow {...modal.config} closeOnConfirm />
          )}
        </Modal.PositionOverlay>
      </Modal.Portal>
    </Modal.Root>
  );
}

type ConfirmModalWindowProps = Options & {
  closeOnConfirm: boolean;
  confirmText?: string;
};

export function ConfirmModalWindow(props: ConfirmModalWindowProps) {
  const { closeOnConfirm, confirmText = 'Confirm' } = props;

  const confirmButton = (
    <Button onClick={props.onConfirm} variant="primary">
      {confirmText}
    </Button>
  );

  return (
    <Modal.Window
      header={
        props.isEditingAsAdmin && (
          <Modal.Header>
            <Badge variant="admin" size={1}>
              <AdminIcon />
              <span>Editing as admin</span>
            </Badge>
          </Modal.Header>
        )
      }
      footer={
        <Modal.Footer>
          <Modal.Close asChild>
            <Button variant="secondary">Cancel</Button>
          </Modal.Close>
          {closeOnConfirm ? (
            <Modal.Close asChild>{confirmButton}</Modal.Close>
          ) : (
            <>{confirmButton}</>
          )}
        </Modal.Footer>
      }
    >
      <Modal.BodyTitle title={props.title} description={props.description} />
    </Modal.Window>
  );
}
